"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
const SetMeal = () => {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    // eslint-disable-next-line max-len
    d: "M19.05 14.56L1.08 15.5L1 14L18.98 13.06L19.05 14.56ZM19 16.48H1V17.98H19V16.48ZM20 2V9C20 10.1 19.1 11 18 11H2C0.9 11 0 10.1 0 9V2C0 0.9 0.9 0 2 0H18C19.1 0 20 0.9 20 2ZM18 3C16.32 3 14.96 3.98 14.79 5.23C14.15 4.5 12.06 2.5 8.25 2.5C3.58 2.5 1.5 5.5 1.5 5.5C1.5 5.5 3.58 8.5 8.25 8.5C12.06 8.5 14.15 6.5 14.79 5.77C14.96 7.02 16.32 8 18 8V3Z",
    fill: "#75767A"
  }));
};
var _default = exports.default = SetMeal;